import { h, Component } from 'preact';
import Store from 'store/store';
import { Howl, Howler } from 'howler';
import { joinClasses } from 'utils/utils';

import s from 'components/bolt/sound/sound.sss';

export default class Sound extends Component {
	constructor(props) {
		super(props);
		this.state = {
			playing: false,
			initialised: false,
			muted: false,
			playStart: new Date(),
			muteTracked: false,
			hasLooped: false,
		};

		this.paused = true;
		this.documentHidden = false;

		this.onPlayMusic = this.onPlayMusic.bind(this);
		this.onResumeMusic = this.onResumeMusic.bind(this);
		this.onPauseMusic = this.onPauseMusic.bind(this);
		this.onVisibilityChange = this.onVisibilityChange.bind(this);
	}

	componentDidMount() {
		const { audioRoot, activePage } = this.props;

		this.soundtrack = new Howl({
			src: [`${audioRoot}/bg.ogg`, `${audioRoot}/bg.mp3`],
			loop: true,
			onend: () => {
				this.setState({ hasLooped: true });
			},
		});

		Store.on('PLAY_MUSIC', this.onPlayMusic);
		Store.on('RESUME_MUSIC', this.onResumeMusic);
		Store.on('PAUSE_MUSIC', this.onPauseMusic);
		document.addEventListener('visibilitychange', this.onVisibilityChange);

		document.addEventListener(
			'click',
			() => {
				if (activePage !== 'livestream') {
					this.onPlayMusic();
				} else {
					this.setState({ initialised: true });
				}
			},
			{ once: true },
		);
	}

	componentDidUpdate(prevProps) {
		const { muted } = this.props;
		if (muted !== prevProps.muted) {
			Howler.mute(muted || this.paused || this.documentHidden);
		}
	}

	componentWillUnmount() {
		Store.off('PLAY_MUSIC', this.onPlayMusic);
		Store.off('RESUME_MUSIC', this.onResumeMusic);
		Store.off('PAUSE_MUSIC', this.onPauseMusic);
		document.removeEventListener('visibilitychange', this.onVisibilityChange);
		document.removeEventListener('click', this.onPlayMusic);
	}

	onVisibilityChange() {
		this.documentHidden = document.visibilityState === 'visible' ? false : true;
		Howler.mute(this.props.muted || this.paused || this.documentHidden);
	}

	onPlayMusic() {
		if (this.state.initialised) {
			this.setState({ playStart: new Date() });
			this.onResumeMusic();
			return;
		}
		this.setState({ playing: true, initialised: true });
		this.soundtrack.play();
	}

	onResumeMusic() {
		if (!this.state.playing && this.state.initialised) {
			this.setState({ playing: true });
			this.soundtrack.play();
		}
	}

	onPauseMusic() {
		if (this.state.playing) {
			this.setState({ playing: false });
			this.soundtrack.pause();
		}
	}

	toggleMuteMusic() {
		if (!this.state.initialised) {
			return;
		}
		if (!this.state.muteTracked) {
			if (this.state.hasLooped) {
				Store.emit('TRACK_MUSIC_MUTED', { percentage: 100 });
			} else {
				const timeInS = (new Date() - this.state.playStart) / 1000;
				const progress = Math.min(Math.min(timeInS / this.soundtrack.duration(), 1) * 100, 100);
				Store.emit('TRACK_MUSIC_MUTED', { percentage: Math.floor(progress / 25) * 25 });
			}
			this.setState({ muteTracked: true });
		}
		const newState = !this.state.muted;
		this.setState({ muted: newState });
		if (newState) {
			this.onPauseMusic();
		} else {
			this.onPlayMusic();
		}
		Howler.mute(newState);
	}

	render() {
		const { appData } = Store.get();
		const { copy, urls } = appData || {};

		const imgRoot = urls?.roots?.image;
		return (
			<button onClick={this.toggleMuteMusic.bind(this)} class={joinClasses(s.soundToggle, (this.state.muted || !this.state.playing) && s.muted)}>
				<img alt={copy.siteCopy.iconSoundTogglePlay} src={`${imgRoot}/icon_sound.svg`} />
			</button>
		);
	}
}
